import { noise } from '@chainsafe/libp2p-noise';
import { circuitRelayTransport } from '@libp2p/circuit-relay-v2';
import { identify } from '@libp2p/identify';
import { webSockets } from '@libp2p/websockets';
import { webTransport } from '@libp2p/webtransport';
import { yamux } from '@libp2p/yamux';
import { createLibp2p, type Libp2p } from 'libp2p';

import { shouldDenyBrowserDialMultiaddr } from './multiaddr';

export async function createLibp2pNode(): Promise<Libp2p> {
  return createLibp2p({
    transports: [webTransport(), webSockets(), circuitRelayTransport()],
    streamMuxers: [yamux()],
    connectionGater: {
      denyDialMultiaddr: shouldDenyBrowserDialMultiaddr,
    },
    connectionEncrypters: [noise()],
    services: {
      identify: identify(),
    },
  });
}
